"use client";

import { home } from "@faire/deprecated-retailer-visitor-shared/paths/index";
import { SignupFormContainer } from "@faire/deprecated-retailer-visitor-shared/views/SignUp/_components/CommonStyles";
import { SignUpTitle } from "@faire/deprecated-retailer-visitor-shared/views/SignUp/_components/SignUpTitle";
import { useSignUpEventTracker } from "@faire/deprecated-retailer-visitor-shared/views/SignUp/_hooks/useSignUpEventTracker";
import { useSignUpRequest } from "@faire/deprecated-retailer-visitor-shared/views/SignUp/SignUpRequestContext";
import { Step } from "@faire/deprecated-retailer-visitor-shared/views/SignUp/Step";
import { useMutation as useAddToWaitListMutation } from "@faire/web-api--source/endpoints/www/api/user/waitlist/post-hooks";
import { ICreateWaitlistedSignUpRequest } from "@faire/web-api--source/indigofair/data/ICreateWaitlistedSignUpRequest";
import { IWaitlistedSignUp } from "@faire/web-api--source/indigofair/data/IWaitlistedSignUp";
import notifyMeSuccessPath from "@faire/web-api--source/routes/www/welcome/r/notify-me/success";
import { useStrictLocalization } from "@faire/web/common/localization";
import { Button } from "@faire/web/slate/Button";
import { Column } from "@faire/web/slate/Layout";
import { Spacer } from "@faire/web/slate/spacing";
import { Typography } from "@faire/web/slate/Typography";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";

export const NotifyMeStep: React.FC = () => {
  const { strictLocalize } = useStrictLocalization();
  const history = useHistory();
  const { mutate: addToWaitList, isPending } = useAddToWaitListMutation();

  const { trackView, trackSubmit } = useSignUpEventTracker(Step.NOTIFY_ME);
  const [{ country, user }] = useSignUpRequest(["country", "user"]);

  const handleNotifyMeClick = () => {
    trackSubmit();
    addToWaitList(
      [
        ICreateWaitlistedSignUpRequest.build({
          user_info: IWaitlistedSignUp.build({
            email_address: user?.email_address,
            first_name: user?.first_name,
            last_name: user?.last_name,
            country,
          }),
        }),
      ],
      {
        onSuccess: () => {
          history.replace(notifyMeSuccessPath());
        },
      }
    );
  };

  const handleMaybeLaterClick = () => {
    trackSubmit();
  };

  useEffect(() => {
    trackView();
  }, [trackView]);

  return (
    <SignupFormContainer>
      <Column>
        <SignUpTitle
          title={strictLocalize({
            id: "eESJDN",
            defaultMessage: "We’ll let you know when Faire is in your country",
            description: {
              img: "https://cdn.faire.com/fastly/be56110e39643bd1db5a4ad9c98126c780b1316077f7cdc2787440db4da451e4.png",
              text: "Title for the notify-me step to allow users to opted-in to be notified when Faire is available in their country.",
            },
          })}
        />
        <Spacer height="3x" />
        <Typography>
          <StrictLocalMsg
            id="QP+F/P"
            defaultMessage="While we’re not currently live in your country, we are working every day to make more locations available on Faire. If you’d like to know when we arrive in your country, we can email you."
            description={{
              img: "https://cdn.faire.com/fastly/be56110e39643bd1db5a4ad9c98126c780b1316077f7cdc2787440db4da451e4.png",
              text: "Text for the notify-me step to allow users to opted-in to be notified when Faire is available in their country.",
            }}
          />
        </Typography>
        <Spacer height="5x" />
        <Button onClick={handleNotifyMeClick} loading={isPending}>
          <StrictLocalMsg
            id="Qh5oT1"
            defaultMessage="Notify me"
            description={{
              img: "https://cdn.faire.com/fastly/590bd48b41364593acff37cf811a6381cc4cbaebe811885490a9089dac1f4c9a.png",
              text: "Button text to opted-in to be notified when Faire is available in their country.",
            }}
          />
        </Button>
        <Spacer height="3x" />
        <Button
          variant="tertiary"
          linkTo={home()}
          replace
          onClick={handleMaybeLaterClick}
          style={{ alignSelf: "center" }}
        >
          <StrictLocalMsg
            id="gUz473"
            defaultMessage="Maybe later"
            description={{
              img: "https://cdn.faire.com/fastly/590bd48b41364593acff37cf811a6381cc4cbaebe811885490a9089dac1f4c9a.png",
              text: "Link to redirect the user to the home page if they decided to not opt-in to be notified when Faire is available in their country.",
            }}
          />
        </Button>
      </Column>
    </SignupFormContainer>
  );
};
